const propStateMapping = {
    keyphrase: (request, state) => state.keyphrase && request.setQuestionsKeyphrase(state.keyphrase),
    relatedQuestions: (request, state) => state.relatedQuestions && request.setQuestionsRelatedQuestionsLimit(state.relatedQuestions),
};
export default propStateMapping;
